var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionmarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7,4.65a11,11,0,1,0,11,11A11,11,0,0,0,14.7,4.65Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,14.7,24.65Z",
    transform: "translate(-3.7 -4.65)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.52,9.16a4.34,4.34,0,0,0-2.77,1,.85.85,0,0,0,0,1.29.9.9,0,0,0,1.13,0A2.3,2.3,0,0,1,14.24,11a1.42,1.42,0,0,1,1.54,1.49c0,1.44-2.06,2.43-2.47,4.37a1,1,0,0,0,1,1.19h0a1,1,0,0,0,1-.85c.4-1.83,2.67-2.74,2.67-4.86S16.53,9.16,14.52,9.16Z",
    transform: "translate(-3.7 -4.65)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.28,19.65a1.24,1.24,0,1,0,1.19,1.25A1.19,1.19,0,0,0,14.28,19.65Z",
    transform: "translate(-3.7 -4.65)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmarkIcon);
export default __webpack_public_path__ + "static/media/questionmark-icon.66823736b3bcf4807d9e000fa2bdfc49.svg";
export { ForwardRef as ReactComponent };